function Twitch() {
  return null;
}

Twitch.externalUrl = 'https://twitch.tv/lottel';

export default Twitch;
